import React, { useState } from "react";
import FancyLine from "images/FancyLine.png";
import "./Reserve.css";
import { postReservation } from "api";
import TableFinder from "./TableFinder";
import ReserveForm from "./ReserveForm";
import { motion, AnimatePresence } from "motion/react";
import { fadeInDown } from "animations";
import FoundTable from "./FoundTable";
import { useLocation, useNavigate } from "react-router-dom";
import HolidayPopup from "components/HolidayPopup";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfService from "./TermsOfService";
import SubNav from "components/nav/SubNav";

export default function Reserve() {
  const [editing, setEditing] = useState(false);
  const [table, setTable] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  async function createRes(formData) {
    const newRes = {
      ...table,
      ...formData,
    };

    const response = await postReservation(newRes);
    if (response.status === 201) {
      const id = response.data._id;
      navigate(`/res/${id}/?success`);
    } else console.log(response.status);
  }

  const returnToEdit = () => {
    setTable((prevTable) => ({
      ...prevTable,
      time: "",
    }));
    setEditing(true);
  };

  const showTerms = location.pathname === "/reserve/terms-of-service";
  const showPrivacy = location.pathname === "/reserve/privacy-policy";

  const date = new Date();
  const day = date.getDate();
  const month = date.getMonth();

  const isHolidays = month === 11 || (month === 0 && day === 1);

  if (showTerms) {
    return (
      <>
        <SubNav variant="text">Because compliancy is a must!</SubNav>
        <div className="reserve-container">
          <div className="reserve-section">
            <div className="menu-section-header"> Terms of Service </div>
            <img className="fancy-line" src={FancyLine} alt="" />
            <TermsOfService />
          </div>
        </div>
      </>
    );
  }

  if (showPrivacy) {
    return (
      <>
        <SubNav variant="text">Because compliancy is a must!</SubNav>
        <div className="reserve-container">
          <div className="reserve-section">
            <div className="menu-section-header"> Privacy Policy </div>
            <img className="fancy-line" src={FancyLine} alt="" />
            <PrivacyPolicy />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {isHolidays && <HolidayPopup />}
      <form id="res-form">
        <SubNav variant="text">
          Reserve a table below or by phone at 847-332-2330
        </SubNav>
        <div className="reserve-container">
          <div className="reserve-section">
            <div className="menu-section-header">For a Reservation</div>
            <img className="fancy-line" src={FancyLine} alt="" />
            {(!table || editing) && (
              <div className="table-finder-container">
                <TableFinder
                  table={table}
                  setTable={setTable}
                  editing={editing}
                  setEditing={setEditing}
                />
              </div>
            )}
            <div className="reserve-inputs">
              {table && !editing && (
                <AnimatePresence>
                  <motion.div className="res-info" {...fadeInDown}>
                    <FoundTable table={table} setEditing={returnToEdit} />
                    <ReserveForm createRes={createRes} />
                  </motion.div>
                </AnimatePresence>
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              boxSizing: "border-box",
              justifyContent: "center",
              gap: "40px",
              width: "100%",
              position: "absolute",
              bottom: "20px",
            }}
          >
          </div>
        </div>
      </form>
    </>
  );
}
